import {InjectionToken, Provider} from '@angular/core';
export let LOADER_SERVICE: any = new InjectionToken<any>('tt.loaderService');

export function loaderServiceFactory(i: any): any {
	return i.get('loaderService');
}

export const loaderServiceProvider: Provider = {
	provide: LOADER_SERVICE,
	useFactory: loaderServiceFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/loader.service.ts